export default __webpack_public_path__ + "static/media/oot-icon.2ce5b456.svg";